import * as React from 'react';
import { DeleteForm } from '../DeleteForm';
import { useOuterApiRevokeForm } from './useOuterApiRevokeForm';

export const OuterApiRevokeForm: React.FC = () => {
  const { onsSubmit, isLoading } = useOuterApiRevokeForm();
  return (
    <DeleteForm
      submitText={'Visszavonás'}
      headerText={'Biztos, hogy visszavonja az API integrációt?'}
      onSubmit={onsSubmit}
      inProgress={isLoading}
    />
  );
};
